<template>
  <!-- Upload content -->
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="8">
          <!-- <v-btn class="mr-2" to="/admin/users/add" v-if="listView">Add</v-btn> -->
          <v-btn class="mr-2" to="/admin/users" v-if="!listView">Close</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" v-if="listView">
      <h3 class="mb-4">Users</h3>
      <v-row>
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">First name</th>
                  <th class="text-left">Last name</th>
                  <th class="text-left">Company</th>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.first }}</td>
                  <td>{{ item.last }}</td>
                  <td>{{ item.company }}</td>
                  <td>{{ item.email }}</td>
                  <td>
                    <v-chip class="mr-2" :to="`/admin/users/show/${item.id}`">
                      Show
                    </v-chip>
                    <v-chip class="mr-2" :to="`/admin/users/edit/${item.id}`">
                      Edit
                    </v-chip>
                    <v-chip class="mr-2" :to="`/admin/users/reset/${item.id}`">
                      Reset
                    </v-chip>
                    <v-chip class="mr-2" @click="deleteAlert(item)">
                      Delete
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <router-view></router-view>
    </v-col>

    <v-dialog v-model="dialog" max-width="290" v-if="tempItem">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete</v-card-title
        >
        <v-card-text>{{ tempItem.first }} {{ tempItem.last }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="deleteCancel()">
            Cancel
          </v-btn>

          <v-btn color="amber" @click="deleteItem()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "AdminUserList",
  data() {
    return {
      collection: fb.profilesCollection,
      items: null,
      returnRoute: "AdminUserList",
      dialog: false,
      tempItem: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    listView() {
      return this.$route.name == "AdminUserList" ? true : false;
    },
    containerWidth() {
      return this.listView ? "12" : "4";
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.collection.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((doc) => {
          let post = doc.data();
          items.push(post);
        });
        this.items = items;
      });
    },
    deleteAlert(item) {
      this.tempItem = item;
      this.dialog = true;
    },
    deleteCancel() {
      this.tempItem = null;
      this.dialog = false;
    },
    deleteItem() {
      this.collection
        .doc(this.tempItem.id)
        .delete()
        .then(() => {
          this.tempItem = null;
          this.dialog = false;
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
  },
};
</script>
